<div class="container mt-4">
  <div class="col-md-12">
    <div class="card card-container">
      <img id="profile-img" src="//ssl.gstatic.com/accounts/ui/avatar_2x.png" class="profile-img-card"/>
      @if (!isSuccessful) {
        <form name="form" (ngSubmit)="f.form.valid && onSubmit()"
          #f="ngForm" novalidate>
          <div class="form-group">
            <label for="username">Username</label>
            <input type="text" id="username" class="form-control" name="username" [(ngModel)]="form.username"
              required minlength="3" maxlength="20" #username="ngModel"/>
            @if (username.errors && f.submitted) {
              <div class="alert-danger">
                @if (username.errors.required) {
                  <div>Username is required</div>
                }
                @if (username.errors.minlength) {
                  <div>
                    Username must be at least 3 characters
                  </div>
                }
                @if (username.errors.maxlength) {
                  <div>
                    Username must be at most 20 characters
                  </div>
                }
              </div>
            }
          </div>
          <div class="form-group">
            <label for="email">Email</label>
            <input type="email" id="email" class="form-control" name="email" [(ngModel)]="form.email"
              required email #email="ngModel"/>
            @if (email.errors && f.submitted) {
              <div class="alert-danger">
                @if (email.errors.required) {
                  <div>Email is required</div>
                }
                @if (email.errors.email) {
                  <div>
                    Email must be a valid email address
                  </div>
                }
              </div>
            }
          </div>
          <div class="form-group">
            <label for="password">Password</label>
            <input type="password" id="password" class="form-control" name="password" [(ngModel)]="form.password"
              required minlength="6" #password="ngModel"/>
            @if (password.errors && f.submitted) {
              <div class="alert-danger">
                @if (password.errors.required) {
                  <div>Password is required</div>
                }
                @if (password.errors.minlength) {
                  <div>
                    Password must be at least 6 characters
                  </div>
                }
              </div>
            }
          </div>
          <div class="form-group">
            <button class="btn btn-primary btn-block">VALIDER</button>
          </div>
          @if (f.submitted && isSignUpFailed) {
            <div class="alert alert-warning">
              Une erreur a été rencontrée : <br />{{ errorMessage }}
            </div>
          }
        </form>
      }

      @if (isSuccessful) {
        <div class="alert alert-success">
          Votre demande d'inscription a été envoyée !
        </div>
      }
    </div>
  </div>
</div>
